import {Component, OnInit, Renderer2} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {QuestionnaireService} from '../../../../services/questionnaire.service';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {ErrorDialogComponent} from '../../../user-actions/error-dialog/error-dialog.component';
import {ClinicalHBIResults, Q_CLINICAL_HBI} from '../../../../model/questionnaires/questionnaire-clinical-hbi';
import {MatOptionSelectionChange} from '@angular/material/core';
import {HbiDialogComponent} from '../questionnaire-hbi/questionnaire-hbi.component';

@Component({
  selector: 'app-questionnaire-clinical-hbi',
  templateUrl: './questionnaire-clinical-hbi.component.html',
  styleUrls: ['./questionnaire-clinical-hbi.component.css']
})
export class QuestionnaireClinicalHbiComponent implements OnInit {

  qForm: FormGroup;
  dataSource = Q_CLINICAL_HBI;
  notFocused = false;
  submitted = false;
  show = false;
  displayedColumns = ['position', 'question', 'value'];
  values: string[] = [
    'Artralgia',
    'Uveite',
    'Eritema nodoso',
    'Ulcera aftoide',
    'Pioderma gangrenoso',
    'Fissurazione anale',
    'Comparsa di una nuova fistola',
    'Ascesso'];
  dialogResults = [''];
  dialogScore = 0;
  results = [];
  q = 'question';
  found = false;

  /// toolbar
  back = true;
  destination: string;
  title = 'CLINICAL-HBI';
  user = null;
  uuid = null;
  authorization: boolean;
  doctorID: string;
  patientSSN: string;

  constructor(private questionnaireService: QuestionnaireService,
              public dialog: MatDialog,
              private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit(): void {
    this.qForm = new FormGroup({
      question3: new FormControl({value: ''}, [Validators.required, Validators.min(0), Validators.max(25)]),
    });
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.dataSource.length; ++i) {
      this.results.push(null);
    }

    this.user = JSON.parse(localStorage.getItem('user'));
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    this.route.params.subscribe(params => {
      this.doctorID = params.doctorID;
      this.patientSSN = params.patientSSN;
      this.uuid = params.uuid;
      this.authorization = doctorID.localeCompare(params.doctorID) === 0;
      this.destination = '/patient-clinical-pendings/' + this.doctorID + '/' + this.patientSSN + '/' + this.title.toLowerCase();
      if (params.back.localeCompare('global') === 0) {
        this.destination += '/global';
      } else {
        this.destination += '/local';
      }
      sessionStorage.setItem('destination', JSON.stringify(this.destination));
    });
  }

  selectResult($event: MatOptionSelectionChange, value: string, position: number) {
    if ($event.isUserInput) {
      if (position !== 5) {
        this.results[position - 1] = value.slice(0, 1);
        console.log(this.results);
      } else {
        if (value === 'Si') {
          this.openHbiDialog($event, position, 'Presenza di complicanze');
        } else if (value === 'No') {
          this.results[position - 1] = '0';
          console.log(this.results);
        }
      }
    }
  }

  setResult(position: number) {
    const question = 'question' + position;
    if (position === 3) {
      this.results[position - 1] = this.qForm.get(question).value.toString();
    }
  }

  onSubmit(value) {
    this.submitted = true;
    this.show = true;
    this.found = false;

    if (this.results.length !== this.dataSource.length) {
      this.show = false;
      this.submitted = false;
      this.found = true;
      const msg = 'Non hai finito di completare il questionario!';
      this.openErrorDialog(msg);
    } else {
      for (const r of this.results) {
        if (r === null) {
          this.show = false;
          this.submitted = false;
          this.found = true;
          const msg = 'Non hai finito di completare il questionario!';
          this.openErrorDialog(msg);
          break;
        }
      }

      if (!this.found) {
        let finalScore = 0;

        for (let i = 0; i < this.results.length - 1; ++i) {
          finalScore += parseInt(this.results[i], 10);
        }

        finalScore += this.dialogScore;
        console.log(finalScore);
        const resultToSend = new ClinicalHBIResults(this.doctorID, this.patientSSN, this.results, this.dialogResults, finalScore);
        this.questionnaireService.sendForm(resultToSend, 'clinical-hbi', this.uuid);
      }
    }
  }

  openErrorDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Finestra chiusa');
    });
  }

  openHbiDialog($event: MatOptionSelectionChange, position: number, message: string): void {
    const dialogRef = this.dialog.open(HbiDialogComponent, {
      width: '500px',
      height: '400px',
      data: {message, values: this.values}
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result === undefined) {
        this.openErrorDialog('Non hai effettuato alcuna selezione!');
        $event.source.deselect();
        this.results[position - 1] = null;
      } else {
        this.dialogResults = result;
        this.dialogScore = this.dialogResults.length;
        this.results[position - 1] = this.dialogScore.toString(10);
      }
      console.log('Finestra chiusa');
      console.log(this.results);
    });
  }

  goHome() {
    if (this.user === null) {
      this.router.navigateByUrl('/startup');
    } else {
      this.router.navigateByUrl('/landing');
    }
  }
}
